import { DOMAIN as PARENT_DOMAIN } from '../../constants';

export const DOMAIN = `${PARENT_DOMAIN}.Header`;
